module.exports = __webpack_public_path__ + "static/img/IP-img1.cb72f04e.png";